module.exports = __webpack_public_path__ + "static/media/david.b4c9e4d0.png";